
import Vue from 'vue';

import {Subscription} from 'rxjs';

import * as CorpusStore from '@/store/search/corpus';
import * as FilterStore from '@/store/search/form/filters';

import { selectedSubCorpus$ } from '@/store/search/streams';

import * as BLTypes from '@/types/blacklabtypes';
import {ApiError} from '@/api';

import frac2Percent from '@/mixins/fractionalToPercent';
import { getValueFunctions, valueFunctions } from '@/components/filters/filterValueFunctions';

import Spinner from '@/components/Spinner.vue';
import { RecursiveRequired } from '@/types/helpers';

export default Vue.extend({
	components: {Spinner},
	data: () => ({
		subscriptions: [] as Subscription[],
		subCorpusStats: null as null|RecursiveRequired<BLTypes.BLDocResults>,
		error: null as null|ApiError,
	}),
	computed: {
		activeFilters: FilterStore.get.activeFilters,
		summaryMap(): Record<string, string> {
			const r: Record<string, string> = {};
			this.activeFilters.forEach(f => {
				const summary = getValueFunctions(f).luceneQuerySummary(f.id, f.metadata, f.value);
				if (summary) { r[f.id] = summary; }
			});
			return r;
		},

		totalCorpusTokens(): number { return CorpusStore.getState().corpus!.tokenCount; },
		totalCorpusDocs(): number { return CorpusStore.getState().corpus!.documentCount; }
	},
	methods: {
		frac2Percent
	},
	created() {
		this.subscriptions.push(selectedSubCorpus$.subscribe(v => {
			this.subCorpusStats = v.value || null;
			this.error = v.error || null;
		}));
	},
	destroyed() {
		this.subscriptions.forEach(s => s.unsubscribe());
	}
});
